<div class="report-container">
  <div class="tab-navigation-container">
    <div class="tab-navigation">
      <button class="tab-btn" [class.active]="activeTab === 'pl-report'" (click)="setActiveTab('pl-report')">P/L Report</button>
      <button class="tab-btn" [class.active]="activeTab === 'import'" (click)="setActiveTab('import')">Import</button>
    </div>
  </div>

  <div class="page-container pt-1-5">
  <div class="page-header">
    <h1>Monthly Profit Share Report</h1>
    <div class="controls">
     <button class="action-btn pdf-btn" *ngIf="selectedPeriod && activeTab !== 'import'" (click)="exportTotalPLReport()" [disabled]="isExportingTotalPL || filteredCompanyGridData.length === 0">
        {{ isExportingTotalPL ? 'Exporting...' : 'Export Total P/L' }}
      </button>
      <div class="selection-container">
        <select [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange($event)" class="period-select" [disabled]="isImporting">
          <option value="">-- Select Period --</option>
          <option *ngFor="let period of periods" [value]="period">{{ period }}</option>
        </select>
      </div>
    </div>
  </div>

  <p class="scope-note" *ngIf="activeTab !== 'import'" data-testid="profit-report-scope-note">Showing all authorized companies across all brands.</p>

  <div *ngIf="!selectedPeriod" class="info-message-card mb-2">
    Please select a period to view or import profit reports.
  </div>

  <!-- IMPORT TAB -->
  <div *ngIf="activeTab === 'import'">
  <div class="uploader-section">
    <ng-container *ngIf="selectedPeriod && showUploader">
      <app-excel-uploader [selectedPeriod]="selectedPeriod" [isImporting]="isImporting" (fileSelected)="onFileSelected($any($event))"></app-excel-uploader>
      <div *ngIf="isImporting" class="import-status">
        <span>Importing...</span>
        <button (click)="cancelImport()" class="cancel-btn">Cancel</button>
      </div>
      <div *ngIf="validationErrors.length > 0" class="status-message error">
        <p class="msg-title">Import Failed: The following companies in the file do not match any company in the system.</p>
        <p class="msg-title">Check for special characters in the company name such as commas, period, colons, etc. :</p>
        <ul class="msg-list">
          <li *ngFor="let company of validationErrors">{{ company }}</li>
        </ul>
      </div>
      <div *ngIf="validationWarnings.length > 0" class="status-message warning">
        <p class="msg-title">Warning: The following companies were skipped as they do not exist in the system. Import completed for existing companies.</p>
        <ul class="msg-list">
          <li *ngFor="let company of validationWarnings">{{ company }}</li>
        </ul>
      </div>
      <div *ngIf="importSuccessMessage" class="status-message success">
        {{ importSuccessMessage }}
      </div>
    </ng-container>
    <app-upload-history 
      collectionName="profit_report_upload_history" 
      (delete)="onDeleteHistory($event)" 
      (deleteFile)="onDeleteSingleFile($event)"
      class="upload-history-container">
    </app-upload-history>
  </div>
  </div>

  <!-- MANAGEMENT TAB -->
  <div *ngIf="activeTab !== 'import'">
    <div *ngIf="selectedPeriod && !isFileProcessed && !isImporting" class="info-message-card mb-2">
      No expense data imported for {{ selectedPeriod }}. Revenue and SMRS fees will still be calculated. Please upload an Excel file to include expenses.
    </div>

  <!-- Company Grid -->
  <div class="report-body" *ngIf="selectedPeriod && !isImporting">

    <!-- Dashboard Stats -->
    <div class="dashboard-container">
      <div class="stat-card">
        <div class="stat-title">Total Revenue (USD)</div>
        <div class="stat-value income">{{ dashboardStats.totalRevenue | currency }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-title">Total Expenses and Fees (USD)</div>
        <div class="stat-value expense">({{ dashboardStats.totalExpenses | currency }})</div>
        <div class="stat-sub">SMRS Fees: ({{ dashboardStats.totalFees | currency }})</div>
      </div>
      <div class="stat-card">
        <div class="stat-title">Net Profit (USD)</div>
        <div class="stat-value" [ngClass]="{'income': dashboardStats.netProfit >= 0, 'expense': dashboardStats.netProfit < 0}">
          <ng-container *ngIf="dashboardStats.netProfit < 0">({{ -dashboardStats.netProfit | currency }})</ng-container>
          <ng-container *ngIf="dashboardStats.netProfit >= 0">{{ dashboardStats.netProfit | currency }}</ng-container>
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-title" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.25rem;">
          <span>Partner Distribution</span>
          <div (click)="$event.stopPropagation()">
            <select [(ngModel)]="selectedOwnerId" (ngModelChange)="onPartnerSelectionChange()" class="period-select" style="width: auto; padding: 0.2rem 1.5rem; font-size: 0.8rem; border-color: #e2e8f0; border-radius: 4px; background-color: #f8fafc;">
              <option [ngValue]="null">Select Partner</option>
              <option *ngFor="let owner of distributionOwners" [value]="owner.id">{{ owner.name }}</option>
            </select>
          </div>
        </div>
        <div class="stat-value income">{{ partnerDistributionTotal | currency }}</div>
      </div>
    </div>

    <div class="toolbar-container right-aligned">
      <div class="country-filter-dropdown">
        <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCountryFilterDropdown()">
          <span>{{ filterCountry === 'All' ? 'All Countries' : filterCountry }}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCountryFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
        <div class="dropdown-menu" *ngIf="showCountryFilterDropdown">
          <div class="dropdown-item" (click)="selectCountryFilter('All')">
            <span>All Countries</span>
          </div>
          <div class="dropdown-divider" *ngIf="availableCountries.length > 0"></div>
          <div class="dropdown-scroll">
            <div class="dropdown-item" *ngFor="let c of availableCountries" (click)="selectCountryFilter(c)">
              <span>{{ c }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="company-filter-dropdown">
        <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCompanyFilterDropdown()">
          <span>Select Companies ({{ activeFilterCompanyIdsCount }}/{{ activeTabCompanies.length }})</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCompanyFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
        </button>
        <div class="dropdown-menu" *ngIf="showCompanyFilterDropdown">
          <div class="dropdown-item" (click)="toggleAllCompanyFilter()">
            <input type="checkbox" [checked]="isAllActiveCompaniesSelected" (click)="$event.stopPropagation(); toggleAllCompanyFilter()">
            <span>Select All</span>
          </div>
          <div class="dropdown-item" (click)="toggleKcegOwnedFilter()">
            <input type="checkbox" [checked]="isKcegOwnedSelected" (click)="$event.stopPropagation(); toggleKcegOwnedFilter()">
            <span>Select KCEG Owned</span>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scroll">
            <div class="dropdown-item" *ngFor="let company of activeTabCompanies" (click)="toggleCompanyFilterItem(company.id)">
              <input type="checkbox" [checked]="filterCompanyIds.has(company.id)" (click)="$event.stopPropagation(); toggleCompanyFilterItem(company.id)">
              <span>{{ company.company }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card no-padding" style="overflow: visible;">
      <table class="data-table">
        <thead>
          <tr>
            <th class="col-icon text-center" style="width: 40px;"></th>
            <th class="text-center">Sent</th>
            <th class="text-center">Company Name</th>
            <th class="text-center">Brand</th>
            <th class="text-center">Statement Period</th>
            <th class="text-center">Total Revenue (USD)</th>
            <th class="text-center">Total Expenses and Fees (USD)</th>
            <th class="text-center">Net Profit (USD)</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="isLoadingGrid">
            <td colspan="9" class="loading-container">
              <div class="spinner spinner-center"></div>
              Loading company data...
            </td>
          </tr>
          <ng-container *ngIf="!isLoadingGrid">
            <ng-container *ngFor="let row of filteredCompanyGridData">
            <tr [class.expanded-parent]="expandedCompanyId === row.id">
            <td class="text-center" style="width: 40px;">
              <button class="icon-btn chevron" [class.rotated]="expandedCompanyId === row.id" (click)="toggleCompanyExpansion(row.rawCompany)" style="background:none; border:none; cursor:pointer; padding:4px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [style.transform]="expandedCompanyId === row.id ? 'rotate(90deg)' : 'rotate(0)'" style="transition: transform 0.2s;"><polyline points="9 18 15 12 9 6"></polyline></svg>
              </button>
            </td>
            <td class="text-center">
              <span class="status" [class.status-sent]="row.emailStatus === 'Sent'" [class.status-not-sent]="row.emailStatus !== 'Sent'">
                {{ row.emailStatus || 'Not Sent' }}
              </span>
            </td>
            <td class="fw-500 text-dark">
              {{ row.companyName }}
              <span *ngIf="row.rawCompany?.isFeeCollection" class="badge-indicator badge-fee-collection">Fee Collection</span>
            </td>
            <td class="text-center">{{ row.brand }}</td>
            <td>{{ row.period }}</td>
            <td class="text-right text-success">{{ row.totalRevenue | currency }}</td>
            <td class="text-right text-danger">({{ row.totalStoreOperationFeeUSD | currency }})</td>
            <td class="text-right fw-600">{{ row.netProfit | currency }}</td>
            <td class="text-center">
              <div class="action-buttons-container">
                <button class="action-btn view-btn" (click)="viewReport(row.rawCompany)">View</button>
                <div class="pdf-dropdown-container" style="position: relative; display: inline-block;">
                  <button class="action-btn pdf-btn" (click)="togglePdfDropdown(row.id, $event)" [disabled]="savingCompanyId === row.id">
                    {{ savingCompanyId === row.id ? 'Saving...' : 'PDF ▼' }}
                  </button>
                  <div class="dropdown-menu" *ngIf="activePdfDropdown === row.id" style="right: 0; left: auto; min-width: 140px; text-align: left; top: 100%; margin-top: 4px; padding: 4px 0;">
                    <div class="dropdown-item" (click)="saveReportPdf(row.rawCompany, 'standard'); $event.stopPropagation()">
                      <span>Standard</span>
                    </div>
                    <div class="dropdown-item" *ngIf="row.rawCompany.sis" (click)="saveReportPdf(row.rawCompany, 'sis'); $event.stopPropagation()">
                      <span>Shop in Shop</span>
                    </div>
                    <div class="dropdown-item" *ngIf="row.rawCompany.brokerReport" (click)="saveReportPdf(row.rawCompany, 'broker'); $event.stopPropagation()">
                      <span>Broker Report</span>
                    </div>
                  </div>
                </div>
                <div class="email-dropdown-container" style="position: relative; display: inline-block;">
                  <button class="action-btn email-btn" (click)="toggleEmailDropdown(row.id, $event)" [disabled]="savingCompanyId === row.id" title="Email Report">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 2px;"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg> ▼
                  </button>
                  <div class="dropdown-menu" *ngIf="activeEmailDropdown === row.id" style="right: 0; left: auto; min-width: 140px; text-align: left; top: 100%; margin-top: 4px; padding: 4px 0;">
                    <div class="dropdown-item" (click)="emailSingleReport(row, 'standard'); $event.stopPropagation()">
                      <span>Standard</span>
                    </div>
                    <div class="dropdown-item" *ngIf="row.rawCompany.sis" (click)="emailSingleReport(row, 'sis'); $event.stopPropagation()">
                      <span>Shop in Shop</span>
                    </div>
                    <div class="dropdown-item" *ngIf="row.rawCompany.brokerReport" (click)="emailSingleReport(row, 'broker'); $event.stopPropagation()">
                      <span>Broker Report</span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <!-- Expanded Row (Store Breakdown) -->
          <tr *ngIf="expandedCompanyId === row.id" class="expanded-row">
            <td colspan="9" class="p-0" style="background-color: #f8fafc; padding: 16px;">
              <div class="sub-table-container">
                <ng-container *ngIf="!row.rawCompany?.isFeeCollection">
                <h4 style="margin-top: 0; margin-bottom: 12px; font-size: 14px; color: #334155;">Store Details</h4>
                <table class="data-table sub-table" style="background-color: #ffffff; border: 1px solid #e2e8f0; font-size: 0.9em;">
                  <thead>
                    <tr>
                      <th rowspan="2" class="text-left" style="vertical-align: bottom;">Store ID</th>
                      <th [colSpan]="row.rates.length + 1" class="text-center">Revenue</th>
                      <th [colSpan]="row.rates.length + 1" class="text-center fee-col">SMRS Fees</th>
                      <th rowspan="2" class="text-center" style="vertical-align: bottom;">Action</th>
                    </tr>
                    <tr>
                      <th *ngFor="let rate of row.rates" class="text-right">{{ rate.name }}</th>
                      <th class="text-right">Total Revenue</th>
                      <th *ngFor="let rate of row.rates" class="text-right fee-col">{{ rate.name }}<br><span style="font-size: 0.85em; font-weight: normal;">({{ rate.rate }}%)</span></th>
                      <th class="text-right fee-col">Total Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let store of row.storeDetails">
                      <td class="text-left fw-500">{{ store.storeId }}</td>
                      <td *ngFor="let rate of row.rates" class="text-right">{{ store.revenues[rate.name] | currency }}</td>
                      <td class="text-right fw-600 text-success">{{ store.totalRevenue | currency }}</td>
                      <td *ngFor="let rate of row.rates" class="text-right fee-col">({{ store.fees[rate.name] | currency }})</td>
                      <td class="text-right fw-600 text-danger fee-col">({{ store.totalFee | currency }})</td>
                      <td class="text-center">
                        <button class="action-btn email-btn" (click)="emailStoreReport(row, store)" title="Email Store Report" style="padding: 4px 8px;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="row.storeDetails.length === 0">
                      <td [attr.colspan]="row.rates.length * 2 + 3" class="text-center empty-table-msg">No store data available.</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th class="text-left">Total</th>
                      <th *ngFor="let rate of row.rates" class="text-right">{{ row.storeTotals.revenues[rate.name] | currency }}</th>
                      <th class="text-right">{{ row.storeTotals.totalRevenue | currency }}</th>
                      <th *ngFor="let rate of row.rates" class="text-right fee-col">({{ row.storeTotals.fees[rate.name] | currency }})</th>
                      <th class="text-right fee-col">({{ row.storeTotals.totalFee | currency }})</th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
                </ng-container>

                <ng-container *ngIf="row.rawCompany?.isFeeCollection">
                  <h4 style="margin-top: 0; margin-bottom: 12px; font-size: 14px; color: #334155;">Fees Collected Details</h4>
                  <table class="data-table sub-table" style="background-color: #ffffff; border: 1px solid #e2e8f0; font-size: 0.9em;">
                    <thead>
                      <tr>
                        <th class="text-left">Company</th>
                        <th class="text-center">Date</th>
                        <th class="text-center">Status</th>
                        <th class="text-right">Amount</th>
                        <th class="text-right">{{ row.brand === 'K-Photo Lavie' ? 'Commission' : 'LK Fee' }}</th>
                        <th class="text-right">KCEG Fee</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of row.feeCollectionBreakdown">
                        <td class="text-left fw-500">{{ item.companyName }}</td>
                        <td class="text-center">{{ item.date?.toDate ? (item.date.toDate() | date:'shortDate') : (item.date | date:'shortDate') }}</td>
                        <td class="text-center">
                          <span class="status" [class.status-paid]="item.status === 'Paid'" [class.status-partial]="item.status === 'Partial'" [class.status-not-paid]="item.status !== 'Paid' && item.status !== 'Partial' && item.status !== 'Canceled'" [class.status-canceled]="item.status === 'Canceled'">
                            {{ item.status || 'N/A' }}
                          </span>
                        </td>
                        <td class="text-right">{{ item.amount | currency }}</td>
                        <td class="text-right">
                          <span *ngIf="item.lfcFee">{{ item.lfcFee | currency }}</span>
                          <span *ngIf="!item.lfcFee" style="color: #cbd5e1;">-</span>
                        </td>
                        <td class="text-right">
                          <span *ngIf="item.kcegFee">{{ item.kcegFee | currency }}</span>
                          <span *ngIf="!item.kcegFee" style="color: #cbd5e1;">-</span>
                        </td>
                      </tr>
                      <tr *ngIf="!row.feeCollectionBreakdown || row.feeCollectionBreakdown.length === 0">
                        <td colspan="6" class="text-center empty-table-msg">No fee collected data available.</td>
                      </tr>
                    </tbody>
                    <tfoot *ngIf="row.feeCollectionBreakdown && row.feeCollectionBreakdown.length > 0">
                      <tr>
                        <th colspan="3" class="text-left">Total Fees Collected</th>
                        <th class="text-right">{{ row.totalFeeCollectionAmount | currency }}</th>
                        <th class="text-right">{{ row.totalFeeCollectionLfcFee | currency }}</th>
                        <th class="text-right">{{ row.totalFeeCollectionKcegFee | currency }}</th>
                      </tr>
                      <tr *ngIf="row.isInternational">
                        <th colspan="3" class="text-left">Total Fees Collected (USD) <span class="rate-note">(Rate: {{ row.exchangeRate | number:'1.4-4' }})</span></th>
                        <th class="text-right">{{ (row.totalFeeCollectionAmount * row.exchangeRate) | currency:'USD' }}</th>
                        <th class="text-right">{{ (row.totalFeeCollectionLfcFee * row.exchangeRate) | currency:'USD' }}</th>
                        <th class="text-right">{{ (row.totalFeeCollectionKcegFee * row.exchangeRate) | currency:'USD' }}</th>
                      </tr>
                    </tfoot>
                  </table>
                </ng-container>
              </div>
            </td>
          </tr>
          </ng-container>
          <tr *ngIf="filteredCompanyGridData.length === 0">
              <td colspan="9" class="empty-table-msg-large">No companies found.</td>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  </div>

  <!-- Report Modal -->
  <div class="modal-overlay" *ngIf="isReportModalOpen" (click)="closeReportModal()">
    <div class="modal-content large-modal" (click)="$event.stopPropagation()">
    
    <div class="modal-sticky-header">
      <h2>Profit Report</h2>
      <div class="header-actions">
        <select *ngIf="selectedCompany?.sis || selectedCompany?.brokerReport" [(ngModel)]="reportType" (ngModelChange)="onReportTypeChange()" class="report-type-select">
          <option value="standard">Standard</option>
          <option *ngIf="selectedCompany?.sis" value="sis">Shop in Shop</option>
          <option *ngIf="selectedCompany?.brokerReport" value="broker">Broker Report</option>
        </select>
        <button class="action-btn" (click)="printReport()">Print</button>
        <button class="close-btn-static" (click)="closeReportModal()">&times;</button>
      </div>
    </div>
    
    <div *ngIf="isLoadingReport" class="loading-overlay">
      <div class="spinner"></div>
      <p>Loading Report Data...</p>
    </div>

    <ng-container *ngIf="!isLoadingReport">
    <!-- Report Header Card -->
    <div class="card header-card">
      <div class="company-info">
        <h2>{{ reportData.companyName }}</h2>
        <p class="subtle" *ngIf="reportData.address">{{ reportData.address }}</p>
      </div>
      <div class="date-info">
        <div class="info-item">
          <label>Statement Period</label>
          <span>{{ reportData.period }}</span>
        </div>
        <div class="info-item">
          <label>Date</label>
          <span>{{ reportData.date }}</span>
        </div>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="summary-grid">
      <div class="card summary-card">
        <label>{{ selectedCompany?.isFeeCollection ? 'Total Fees Collected (USD)' : 'Total Sales Revenue (USD)' }}</label> 
        <span class="value income">{{ (reportData.isInternational ? reportData.totalSalesUSD : totalSales) | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>

      <ng-container *ngIf="reportType === 'sis' || reportType === 'broker'">
        <div class="card summary-card">
          <label>Total SMRS Fees (USD)</label>
          <span class="value expense">({{ (reportData.isInternational ? reportData.totalFeesUSD : totalFees) | currency:'USD':'symbol':'1.2-2' }})</span>
        </div>
        <div class="card summary-card">
          <label>CC Charge ({{ reportData.sisCcRate }}%)</label>
          <span class="value expense">({{ reportData.ccChargeAmount | currency:'USD':'symbol':'1.2-2' }})</span>
        </div>
        <div class="card summary-card highlight">
          <label>{{ reportType === 'broker' ? reportData.companyName : 'Shop' }} Net Profit ({{ reportData.sisProfitShare }}%)</label>
          <span class="value">{{ (reportType === 'broker' ? brokerNetProfit : shopNetProfit) | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="reportType !== 'sis' && reportType !== 'broker'">
        <div class="card summary-card">
          <label>Total Expense & Fee (USD)</label>
          <span class="value expense">({{ (reportData.isInternational ? reportData.totalStoreOperationFeeUSD : totalStoreOperationFee) | currency:'USD':'symbol':'1.2-2' }})</span>
          <div class="stat-sub" style="margin-top: 4px;" *ngIf="!selectedCompany?.isFeeCollection">SMRS Fees: ({{ (reportData.isInternational ? reportData.totalFeesUSD : totalFees) | currency:'USD':'symbol':'1.2-2' }})</div>
        </div>
        <div class="card summary-card highlight">
          <label>
            Net Profit (USD)
          </label>
          <span class="value">{{ (reportData.isInternational ? reportData.totalNetProfitUSD : totalNetProfit) | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
      </ng-container>
    </div>

    <!-- Main Content Grid -->
    <div class="main-grid">
      <!-- Left Column: Sales & Expenses -->
      <div class="card main-card" *ngIf="!selectedCompany?.isFeeCollection">
        <h3>Sales & Fee Breakdown{{ reportData.isInternational ? ' (' + reportData.currency + ')' : '' }}</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th class="text-right">Sales Revenue</th>
              <th class="text-right">Fee Rate</th>
              <th class="text-right">Fee Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of reportData.salesBreakdown">
              <td>{{ item.name }}</td>
              <td class="text-right">{{ item.revenue | currency }}</td>
              <td class="text-right">{{ item.rate }}%</td>
              <td class="text-right fee-col">({{ item.fee | currency }})</td>
            </tr>
            <tr *ngIf="!reportData.salesBreakdown || reportData.salesBreakdown.length === 0">
              <td colspan="4" class="text-center empty-table-msg">There is no revenue & fee present for this period</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <th class="text-right">{{ totalSales | currency }}</th>
              <th></th>
              <th class="text-right fee-col">({{ totalFees | currency }})</th>
            </tr>
            <tr *ngIf="reportData.isInternational">
              <th>Total (USD) <span class="rate-note">(Rate: {{ reportData.exchangeRate | number:'1.4-4' }})</span></th>
              <th class="text-right">{{ reportData.totalSalesUSD | currency:'USD' }}</th>
              <th></th>
              <th class="text-right fee-col">({{ reportData.totalFeesUSD | currency:'USD' }})</th>
            </tr>
          </tfoot>
        </table>
      </div>
      
      <div class="card main-card" *ngIf="selectedCompany?.isFeeCollection">
        <h3>Fees Collected (By Company){{ reportData.isInternational ? ' (' + reportData.currency + ')' : '' }}</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th class="text-left">Company</th>
              <th class="text-center">Date</th>
              <th class="text-center">Status</th>
              <th class="text-right">Amount</th>
              <th class="text-right">{{ getBrandName(selectedCompany?.brand || '') === 'K-Photo Lavie' ? 'Commission' : 'LK Fee' }}</th>
              <th class="text-right">KCEG Fee</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of reportData.feeCollectionBreakdown">
              <td class="text-left">{{ item.companyName }}</td>
              <td class="text-center">{{ item.date?.toDate ? (item.date.toDate() | date:'shortDate') : (item.date | date:'shortDate') }}</td>
              <td class="text-center">
                <span class="status" [class.status-paid]="item.status === 'Paid'" [class.status-partial]="item.status === 'Partial'" [class.status-not-paid]="item.status !== 'Paid' && item.status !== 'Partial' && item.status !== 'Canceled'" [class.status-canceled]="item.status === 'Canceled'">
                  {{ item.status || 'N/A' }}
                </span>
              </td>
              <td class="text-right">{{ item.amount | currency }}</td>
              <td class="text-right">
                <span *ngIf="item.lfcFee">{{ item.lfcFee | currency }}</span>
                <span *ngIf="!item.lfcFee" style="color: #cbd5e1;">-</span>
              </td>
              <td class="text-right">
                <span *ngIf="item.kcegFee">{{ item.kcegFee | currency }}</span>
                <span *ngIf="!item.kcegFee" style="color: #cbd5e1;">-</span>
              </td>
            </tr>
            <tr *ngIf="!reportData.feeCollectionBreakdown || reportData.feeCollectionBreakdown.length === 0">
              <td colspan="6" class="text-center empty-table-msg">There is no fee collected present for this period</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="3" class="text-left">Total Fees Collected</th>
              <th class="text-right">{{ totalSales | currency }}</th>
              <th class="text-right">{{ totalFeeCollectionLfcFee | currency }}</th>
              <th class="text-right">{{ totalFeeCollectionKcegFee | currency }}</th>
            </tr>
            <tr *ngIf="reportData.isInternational">
              <th colspan="3" class="text-left">Total Fees Collected (USD) <span class="rate-note">(Rate: {{ reportData.exchangeRate | number:'1.4-4' }})</span></th>
              <th class="text-right">{{ reportData.totalSalesUSD | currency:'USD' }}</th>
              <th class="text-right">{{ (totalFeeCollectionLfcFee * reportData.exchangeRate!) | currency:'USD' }}</th>
              <th class="text-right">{{ (totalFeeCollectionKcegFee * reportData.exchangeRate!) | currency:'USD' }}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Right Column: Profit Share -->
      <div class="card main-card" *ngIf="reportType !== 'sis' && reportType !== 'broker'">
        <h3>Partnership Profit Share</h3>
        <div class="line-items">
          <div class="line-item header">
            <span class="label">Total Net Profit for Distribution{{ reportData.isInternational ? ' (USD)' : '' }}</span>
            <span class="amount">{{ (reportData.isInternational ? reportData.totalNetProfitUSD : totalNetProfit) | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          <ng-container *ngIf="reportData.reserveRate! > 0">
            <div class="line-item" style="font-size: 0.9em;">
              <span class="label" style="padding-left: 1.5rem; color: #64748b;">Next Month Reserve ({{ reportData.reserveRate }}%)</span>
              <span class="amount expense">({{ reportData.reserveAmount | currency:'USD':'symbol':'1.2-2' }})</span>
            </div>
            <div class="line-item header">
              <span class="label">Final Net</span>
              <span class="amount">{{ reportData.finalNetProfit | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
          </ng-container>
          <ng-container *ngFor="let partner of reportData.partners">
            <div class="line-item">
              <span class="label">{{ partner.name }} ({{ partner.percentage }}%)</span>
              <span class="amount">{{ partner.amount | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Operating Expenses (Full Width) -->
    <div class="card main-card mt-1-5" *ngIf="reportType !== 'sis' && reportType !== 'broker'">
      <h3 class="section-title mt-0">Operating Expenses and Fees</h3>
      <div class="line-items grid-2-col">
        <ng-container *ngFor="let item of reportData.expenses">

          <!-- Add Adjustment Button Area -->
          <ng-container *ngIf="item.label === 'Total Company Expense and Fee' || item.label === 'Total Company Expense and Fee (USD)'">
            <div class="line-item full-width" *ngIf="!isAddingAdjustment" style="justify-content: flex-start; padding-top: 0.5rem; margin-bottom: 0.5rem;">
              <button class="action-btn view-btn" (click)="isAddingAdjustment = true">+ Add Adjustment</button>
            </div>
            
            <div class="line-item full-width" *ngIf="isAddingAdjustment" style="display: flex; gap: 10px; align-items: center; padding-top: 0.5rem; margin-bottom: 0.5rem;">
              <input type="text" [(ngModel)]="newAdjustment.description" placeholder="Description" style="flex: 2; padding: 0.4rem; border: 1px solid #cbd5e1; border-radius: 4px;">
              <input type="number" [(ngModel)]="newAdjustment.amount" placeholder="Amount" style="flex: 1; padding: 0.4rem; border: 1px solid #cbd5e1; border-radius: 4px;">
              <button class="action-btn pdf-btn" (click)="saveCustomAdjustment()">Save</button>
              <button class="action-btn cancel" (click)="isAddingAdjustment = false">Cancel</button>
            </div>
          </ng-container>

          <div class="line-item" [class.header]="item.isHeader" [class.full-width]="item.isHeader || $any(item).isFullWidth">
            <span class="label">
              {{ item.label }}
              <button *ngIf="$any(item).isAdjustment" (click)="deleteCustomAdjustment($any(item).adjustmentIndex, $any(item).adjustmentType)" style="background: none; border: none; color: #ef4444; cursor: pointer; font-size: 0.9rem; padding: 0 4px; margin-left: 4px;" title="Delete Adjustment">🗑️</button>
            </span>
            <span class="amount" *ngIf="!$any(item).hideAmount" [class.expense]="(item.amount || 0) < 0">
              <ng-container *ngIf="item.amount !== null; else dash">
                {{ item.amount | currency:'USD':'symbol':'1.2-2' }}
              </ng-container>
              <ng-template #dash>-</ng-template>
            </span>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Bank Transaction Details (Full Width) -->
    <div class="card main-card mt-1-5" *ngIf="reportType !== 'sis' && reportType !== 'broker'">
      <h3 class="section-title mt-0">Bank Transaction Details for {{ reportData.companyName }}</h3>
      <table class="data-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Check #</th>
            <th>Description</th>
            <th>Category</th>
            <th class="text-right">Amount</th>
            <!-- <th class="text-center">Action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of reportData.rawImportedData">
            <td>{{ item.date | date:'shortDate' }}</td>
            <td>{{ item.checkNumber }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.category }}</td>
            <td class="text-right">{{ item.amount | currency:'USD':'symbol':'1.2-2' }}</td>
            <!-- <td class="text-center">
              <button class="action-btn danger" style="padding: 2px 6px;" (click)="deleteTransactionItem(item)" title="Delete Transaction">🗑️</button>
            </td> -->
          </tr>
          <tr *ngIf="!reportData.rawImportedData || reportData.rawImportedData.length === 0">
            <td colspan="5" class="text-center empty-table-msg">No detailed data available.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Broker Report Store Details (Visible inside Modal) -->
    <app-broker-report *ngIf="reportType === 'broker' && reportData.brokerStoreDetails" [reportData]="reportData" [forPdf]="false"></app-broker-report>

    <!-- SIS Store Details (Modal) -->
    <ng-container *ngIf="reportType === 'sis' && reportData.sisStoreDetails && reportData.sisStoreDetails.length > 0">
      <div *ngFor="let store of reportData.sisStoreDetails" style="margin-top: 3rem; padding-top: 2rem; border-top: 2px dashed #cbd5e1;">
        <div class="card header-card" style="margin-bottom: 1.5rem; background-color: #f8fafc; border: 1px solid #e2e8f0;">
          <div class="company-info">
            <h2 style="margin: 0; color: #1e293b;">{{ store.storeName }} ({{ store.storeId }})</h2>
            <p class="subtle" style="margin-top: 4px;">{{ reportData.companyName }}</p>
          </div>
          <div class="date-info">
            <div class="info-item">
              <label>Statement Period</label>
              <span>{{ reportData.period }}</span>
            </div>
            <div class="info-item">
              <label>Date</label>
              <span>{{ reportData.date }}</span>
            </div>
          </div>
        </div>

        <div class="summary-grid">
          <div class="card summary-card">
            <label>Total Sales Revenue (USD)</label>
            <span class="value income">{{ store.totalSales | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          <div class="card summary-card">
            <label>Total SMRS Fees (USD)</label>
            <span class="value expense">({{ store.totalFees | currency:'USD':'symbol':'1.2-2' }})</span>
          </div>
          <div class="card summary-card">
            <label>CC Charge ({{ reportData.sisCcRate }}%)</label>
            <span class="value expense">({{ store.ccChargeAmount | currency:'USD':'symbol':'1.2-2' }})</span>
          </div>
          <div class="card summary-card highlight">
            <label>Shop Net Profit ({{ reportData.sisProfitShare }}%)</label>
            <span class="value">{{ store.profitShareAmount | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        </div>

        <div class="main-grid" style="grid-template-columns: 1fr;">
          <div class="card main-card">
            <h3>Sales & SMRS Fee Breakdown (USD)</h3>
            <table class="data-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th class="text-right">Sales Revenue</th>
                  <th class="text-right">Fee Rate</th>
                  <th class="text-right">Fee Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of store.salesBreakdown">
                  <td>{{ item.name }}</td>
                  <td class="text-right">{{ item.revenue | currency }}</td>
                  <td class="text-right">{{ item.rate }}%</td>
                  <td class="text-right fee-col">({{ item.fee | currency }})</td>
                </tr>
                <tr *ngIf="!store.salesBreakdown || store.salesBreakdown.length === 0">
                  <td colspan="4" class="text-center empty-table-msg">There is no revenue & fee present for this period</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <th class="text-right">{{ store.totalSales | currency }}</th>
                  <th></th>
                  <th class="text-right fee-col">({{ store.totalFees | currency }})</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Attached Sales Invoices (Visible inside Modal) -->
    <ng-container *ngIf="reportType !== 'sis' && reportType !== 'broker' && reportData.salesInvoices && reportData.salesInvoices.length > 0">
      <div class="card main-card" style="margin-top: 1.5rem;">
        <h3 class="section-title" style="margin-top: 0;">Attached Sales Invoices</h3>
        <app-sales-invoice-template *ngFor="let invoice of reportData.salesInvoices" [invoice]="invoice" style="display: block; margin-top: 20px;"></app-sales-invoice-template>
      </div>
    </ng-container>
    </ng-container>
  </div>
  </div>
</div>
</div>

<!-- Hidden Total P/L PDF Template -->
<div id="total-pl-report-pdf-wrapper">
  <div id="total-pl-pdf-content" class="pdf-wrapper" *ngIf="totalPLData">
    <!-- Header -->
    <div class="card header-card">
      <div class="company-info">
        <h2>Total P/L Report</h2>
        <p>All Brands</p>
      </div>
      <div class="date-info">
        <div class="info-item">
          <label>Statement Period</label>
          <span>{{ selectedPeriod }}</span>
        </div>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="summary-grid">
      <div class="card summary-card">
        <label>Total Sales Revenue (USD)</label>
        <span class="value income">{{ totalPLData.totalSales | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>
      <div class="card summary-card">
        <label>Total Expense & Fee (USD)</label>
        <span class="value expense">({{ totalPLData.totalStoreOperationFeeUSD | currency:'USD':'symbol':'1.2-2' }})</span>
        <div class="stat-sub" style="margin-top: 4px;">SMRS Fees: ({{ totalPLData.totalFees | currency:'USD':'symbol':'1.2-2' }})</div>
      </div>
      <div class="card summary-card highlight">
        <label>Net Profit (USD)</label>
        <span class="value">{{ totalPLData.totalNetProfit | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>
      <div class="card summary-card" *ngIf="selectedOwnerId">
        <label>Partner Distribution: {{ getSelectedOwnerName() }}</label>
        <span class="value income">{{ partnerDistributionTotal | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>
    </div>

    <!-- Main Grid -->
    <div class="main-grid" style="grid-template-columns: 1fr;">
      <div class="card main-card">
        <h3>Sales & SMRS Fee Breakdown (USD)</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th class="text-right">Sales Revenue</th>
              <th class="text-right">Fee Rate</th>
              <th class="text-right">Fee Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of totalPLData.salesBreakdown" class="avoid-page-break">
              <td>{{ item.name }}</td>
              <td class="text-right">{{ item.revenue | currency }}</td>
              <td class="text-right">{{ item.rate }}%</td>
              <td class="text-right fee-col">({{ item.fee | currency }})</td>
            </tr>
            <tr *ngIf="!totalPLData.salesBreakdown || totalPLData.salesBreakdown.length === 0">
              <td colspan="4" class="text-center empty-table-msg">There is no fee present for this period</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <th class="text-right">{{ totalPLData.totalSales | currency }}</th>
              <th></th>
              <th class="text-right fee-col">({{ totalPLData.totalFees | currency }})</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <div class="page-break-before"></div>

    <div class="card main-card">
      <h3 class="section-title" style="margin-top: 0;">Company Data Grid for {{ selectedPeriod }}</h3>
      <table class="data-table">
        <thead>
          <tr>
            <th class="text-left">Company Name</th>
            <th class="text-center">Brand</th>
            <th class="text-center">Statement Period</th>
            <th class="text-right">Total Revenue (USD)</th>
            <th class="text-right">Total Expenses and Fees (USD)</th>
            <th class="text-right">Net Profit (USD)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredCompanyGridData" class="pdf-row">
            <td class="fw-500 text-dark text-left">{{ row.companyName }}</td>
            <td class="text-center">{{ row.brand }}</td>
            <td class="text-center">{{ row.period }}</td>
            <td class="text-right text-success">{{ row.totalRevenue | currency }}</td>
            <td class="text-right text-danger">({{ row.totalStoreOperationFeeUSD | currency }})</td>
            <td class="text-right fw-600">{{ row.netProfit | currency }}</td>
          </tr>
          <tr *ngIf="filteredCompanyGridData.length === 0">
            <td colspan="6" class="empty-table-msg-large">No companies found.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<!-- Duplicate Warning Modal -->
<div class="modal-overlay" *ngIf="duplicateWarningData">
  <div class="modal-content">
    <div class="modal-header warning">
      <h2>Duplicate Import Detected</h2>
    </div>
    <div class="modal-body">
      <p>You have already imported this file for this period.</p>
      <div class="duplicate-info">
        <div class="info-grid">
          <div><strong>File Name:</strong></div>
          <div>{{ duplicateWarningData.existingRecord.fileName }}</div>
          <div><strong>Uploaded:</strong></div>
          <div>{{ duplicateWarningData.existingRecord.uploadedAt | date:'medium' }}</div>
          <div><strong>Records:</strong></div>
          <div>{{ duplicateWarningData.existingRecord.recordCount }}</div>
        </div>
      </div>
      <p>Would you like to re-import? This will replace the previous data.</p>
      <div class="modal-actions">
        <button class="action-btn cancel" (click)="cancelDuplicate()">Cancel</button>
        <button class="action-btn danger" (click)="proceedWithDuplicate()">Proceed & Re-import</button>
      </div>
    </div>
  </div>
</div>

<!-- Hidden PDF Template -->
<div id="profit-report-pdf-content">
  <div id="pdf-content" class="pdf-wrapper">
    <!-- Header -->
    <div class="card header-card">
      <div class="company-info">
        <h2>{{ reportData.companyName }}</h2>
        <p class="subtle" *ngIf="reportData.address">{{ reportData.address }}</p>
      </div>
      <div class="date-info">
        <div class="info-item">
          <label>Statement Period</label>
          <span>{{ reportData.period }}</span>
        </div>
        <div class="info-item">
          <label>Date</label>
          <span>{{ reportData.date }}</span>
        </div>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="summary-grid">
      <div class="card summary-card">
        <label>{{ selectedCompany?.isFeeCollection ? 'Total Fees Collected (USD)' : 'Total Sales Revenue (USD)' }}</label>
        <span class="value income">{{ (reportData.isInternational ? reportData.totalSalesUSD : totalSales) | currency:'USD':'symbol':'1.2-2' }}</span>
      </div>

      <ng-container *ngIf="reportType === 'sis' || reportType === 'broker'">
        <div class="card summary-card">
          <label>Total SMRS Fees (USD)</label>
          <span class="value expense">({{ (reportData.isInternational ? reportData.totalFeesUSD : totalFees) | currency:'USD':'symbol':'1.2-2' }})</span>
        </div>
        <div class="card summary-card">
          <label>CC Charge ({{ reportData.sisCcRate }}%)</label>
          <span class="value expense">({{ reportData.ccChargeAmount | currency:'USD':'symbol':'1.2-2' }})</span>
        </div>
        <div class="card summary-card highlight">
          <label>{{ reportType === 'broker' ? reportData.companyName : 'Shop' }} Net Profit ({{ reportData.sisProfitShare }}%)</label>
          <span class="value">{{ (reportType === 'broker' ? brokerNetProfit : shopNetProfit) | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="reportType !== 'sis' && reportType !== 'broker'">
        <div class="card summary-card">
          <label>Total Expense & Fee (USD)</label>
          <span class="value expense">({{ (reportData.isInternational ? reportData.totalStoreOperationFeeUSD : totalStoreOperationFee) | currency:'USD':'symbol':'1.2-2' }})</span>
          <div class="stat-sub" style="margin-top: 4px;" *ngIf="!selectedCompany?.isFeeCollection">SMRS Fees: ({{ (reportData.isInternational ? reportData.totalFeesUSD : totalFees) | currency:'USD':'symbol':'1.2-2' }})</div>
        </div>
        <div class="card summary-card highlight">
          <label>
            Net Profit (USD)
          </label>
          <span class="value">{{ (reportData.isInternational ? reportData.totalNetProfitUSD : totalNetProfit) | currency:'USD':'symbol':'1.2-2' }}</span>
        </div>
      </ng-container>
    </div>

    <!-- Main Grid -->
    <div class="main-grid">
      <!-- Left Column -->
      <div class="card main-card" *ngIf="!selectedCompany?.isFeeCollection">
        <h3>Sales & Fee Breakdown{{ reportData.isInternational ? ' (' + reportData.currency + ')' : '' }}</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th>Category</th>
              <th class="text-right">Sales Revenue</th>
              <th class="text-right">Fee Rate</th>
              <th class="text-right">Fee Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of reportData.salesBreakdown" class="avoid-page-break">
              <td>{{ item.name }}</td>
              <td class="text-right">{{ item.revenue | currency }}</td>
              <td class="text-right">{{ item.rate }}%</td>
              <td class="text-right fee-col">({{ item.fee | currency }})</td>
            </tr>
            <tr *ngIf="!reportData.salesBreakdown || reportData.salesBreakdown.length === 0">
              <td colspan="4" class="text-center empty-table-msg">There is no fee present for this period</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th>Total</th>
              <th class="text-right">{{ totalSales | currency }}</th>
              <th></th>
              <th class="text-right fee-col">({{ totalFees | currency }})</th>
            </tr>
            <tr *ngIf="reportData.isInternational">
              <th>Total (USD) <span class="rate-note">(Rate: {{ reportData.exchangeRate | number:'1.4-4' }})</span></th>
              <th class="text-right">{{ reportData.totalSalesUSD | currency:'USD' }}</th>
              <th></th>
              <th class="text-right fee-col">({{ reportData.totalFeesUSD | currency:'USD' }})</th>
            </tr>
          </tfoot>
        </table>
      </div>
      
      <div class="card main-card" *ngIf="selectedCompany?.isFeeCollection">
        <h3>Fees Collected (By Company){{ reportData.isInternational ? ' (' + reportData.currency + ')' : '' }}</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th class="text-left">Company</th>
              <th class="text-center">Date</th>
              <th class="text-center">Status</th>
              <th class="text-right">Amount</th>
              <th class="text-right">{{ (selectedCompany?.brand || '').trim() === 'K-Photo Lavie' ? 'Commission' : 'LK Fee' }}</th>
              <th class="text-right">KCEG Fee</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of reportData.feeCollectionBreakdown" class="pdf-row avoid-page-break">
              <td class="text-left">{{ item.companyName }}</td>
              <td class="text-center">{{ item.date?.toDate ? (item.date.toDate() | date:'shortDate') : (item.date | date:'shortDate') }}</td>
              <td class="text-center">{{ item.status || 'N/A' }}</td>
              <td class="text-right">{{ item.amount | currency }}</td>
              <td class="text-right">
                <span *ngIf="item.lfcFee">{{ item.lfcFee | currency }}</span>
                <span *ngIf="!item.lfcFee" style="color: #cbd5e1;">-</span>
              </td>
              <td class="text-right">
                <span *ngIf="item.kcegFee">{{ item.kcegFee | currency }}</span>
                <span *ngIf="!item.kcegFee" style="color: #cbd5e1;">-</span>
              </td>
            </tr>
            <tr *ngIf="!reportData.feeCollectionBreakdown || reportData.feeCollectionBreakdown.length === 0">
              <td colspan="6" class="text-center empty-table-msg">There is no fee collected present for this period</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="3" class="text-left">Total Fees Collected</th>
              <th class="text-right">{{ totalSales | currency }}</th>
              <th class="text-right">{{ totalFeeCollectionLfcFee | currency }}</th>
              <th class="text-right">{{ totalFeeCollectionKcegFee | currency }}</th>
            </tr>
            <tr *ngIf="reportData.isInternational">
              <th colspan="3" class="text-left">Total Fees Collected (USD) <span class="rate-note">(Rate: {{ reportData.exchangeRate | number:'1.4-4' }})</span></th>
              <th class="text-right">{{ reportData.totalSalesUSD | currency:'USD' }}</th>
              <th class="text-right">{{ (totalFeeCollectionLfcFee * reportData.exchangeRate!) | currency:'USD' }}</th>
              <th class="text-right">{{ (totalFeeCollectionKcegFee * reportData.exchangeRate!) | currency:'USD' }}</th>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Right Column -->
      <div class="card main-card" *ngIf="reportType !== 'sis' && reportType !== 'broker'">
        <h3>Partnership Profit Share</h3>
        <div class="line-items">
          <div class="line-item header avoid-page-break">
            <span class="label">Total Net Profit for Distribution{{ reportData.isInternational ? ' (USD)' : '' }}</span>
            <span class="amount">{{ (reportData.isInternational ? reportData.totalNetProfitUSD : totalNetProfit) | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
          <ng-container *ngIf="reportData.reserveRate! > 0">
            <div class="line-item avoid-page-break" style="font-size: 0.9em;">
              <span class="label" style="padding-left: 1.5rem; color: #64748b;">↳ Less: Next Month Reserve ({{ reportData.reserveRate }}%)</span>
              <span class="amount expense">({{ reportData.reserveAmount | currency:'USD':'symbol':'1.2-2' }})</span>
            </div>
            <div class="line-item header avoid-page-break">
              <span class="label">Final Net</span>
              <span class="amount">{{ reportData.finalNetProfit | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
          </ng-container>
          <ng-container *ngFor="let partner of reportData.partners">
            <div class="line-item avoid-page-break">
              <span class="label">{{ partner.name }} ({{ partner.percentage }}%)</span>
              <span class="amount">{{ partner.amount | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-container *ngIf="reportType !== 'sis' && reportType !== 'broker'">
      <div class="page-break-before"></div>
  
      <div class="card main-card">
        <h3 class="section-title">Operating Expenses and Fees</h3>
        <div class="line-items grid-2-col">
          <ng-container *ngFor="let item of reportData.expenses">
            <div class="line-item pdf-row" [class.header]="item.isHeader" [class.full-width]="item.isHeader || $any(item).isFullWidth">
              <span class="label">{{ item.label }}</span>
            <span class="amount" *ngIf="!$any(item).hideAmount" [class.expense]="(item.amount || 0) < 0">
                <ng-container *ngIf="item.amount !== null; else dash">
                  {{ item.amount | currency:'USD':'symbol':'1.2-2' }}
                </ng-container>
                <ng-template #dash>-</ng-template>
              </span>
            </div>
          </ng-container>
        </div>
      </div>
  
      <div class="page-break-before"></div>
  
      <div class="card main-card">
        <h3 class="section-title">Bank Transaction Details for {{ reportData.companyName }}</h3>
        <table class="data-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Check #</th>
              <th>Description</th>
              <th>Category</th>
              <th class="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of reportData.rawImportedData" class="pdf-row">
              <td>{{ item.date | date:'shortDate' }}</td>
              <td>{{ item.checkNumber }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.category }}</td>
              <td class="text-right">{{ item.amount | currency:'USD':'symbol':'1.2-2' }}</td>
            </tr>
            <tr *ngIf="!reportData.rawImportedData || reportData.rawImportedData.length === 0">
              <td colspan="5" class="text-center empty-table-msg">No detailed data available.</td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Appended Sales Invoices -->
      <ng-container *ngIf="reportData.salesInvoices && reportData.salesInvoices.length > 0">
        <div *ngFor="let invoice of reportData.salesInvoices" class="invoice-page-break">
          <app-sales-invoice-template [invoice]="invoice" [forPdf]="true" class="sales-invoice-comp"></app-sales-invoice-template>
        </div>
      </ng-container>
    </ng-container>

    <!-- Broker Report Store Details (PDF) -->
    <app-broker-report *ngIf="reportType === 'broker' && reportData.brokerStoreDetails" [reportData]="reportData" [forPdf]="true"></app-broker-report>

    <!-- SIS Store Details (PDF) -->
    <ng-container *ngIf="reportType === 'sis' && reportData.sisStoreDetails && reportData.sisStoreDetails.length > 0">
      <ng-container *ngFor="let store of reportData.sisStoreDetails; let i = index">
        <div class="before-page-break"></div>
        <div class="sis-pdf-page">
          <div class="card header-card">
            <div class="company-info">
              <h2>{{ store.storeName }} ({{ store.storeId }}) <span class="page-indicator">(Page {{ i + 1 }} of {{ reportData.sisStoreDetails.length }})</span></h2>
              <p class="subtle">{{ reportData.companyName }}</p>
            </div>
            <div class="date-info">
              <div class="info-item">
                <label>Statement Period</label>
                <span>{{ reportData.period }}</span>
              </div>
              <div class="info-item">
                <label>Date</label>
                <span>{{ reportData.date }}</span>
              </div>
            </div>
          </div>

          <div class="summary-grid">
            <div class="card summary-card">
              <label>Total Sales Revenue (USD)</label>
              <span class="value income">{{ store.totalSales | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
            <div class="card summary-card">
              <label>Total SMRS Fees (USD)</label>
              <span class="value expense">({{ store.totalFees | currency:'USD':'symbol':'1.2-2' }})</span>
            </div>
            <div class="card summary-card">
              <label>CC Charge ({{ reportData.sisCcRate }}%)</label>
              <span class="value expense">({{ store.ccChargeAmount | currency:'USD':'symbol':'1.2-2' }})</span>
            </div>
            <div class="card summary-card highlight">
              <label>Shop Net Profit ({{ reportData.sisProfitShare }}%)</label>
              <span class="value">{{ store.profitShareAmount | currency:'USD':'symbol':'1.2-2' }}</span>
            </div>
          </div>

          <div class="main-grid" style="grid-template-columns: 1fr;">
            <div class="card main-card">
              <h3>Sales & SMRS Fee Breakdown (USD)</h3>
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th class="text-right">Sales Revenue</th>
                    <th class="text-right">Fee Rate</th>
                    <th class="text-right">Fee Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of store.salesBreakdown" class="pdf-row">
                    <td>{{ item.name }}</td>
                    <td class="text-right">{{ item.revenue | currency }}</td>
                    <td class="text-right">{{ item.rate }}%</td>
                    <td class="text-right fee-col">({{ item.fee | currency }})</td>
                  </tr>
                  <tr *ngIf="!store.salesBreakdown || store.salesBreakdown.length === 0">
                    <td colspan="4" class="text-center empty-table-msg">There is no revenue & fee present for this period</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th>Total</th>
                    <th class="text-right">{{ store.totalSales | currency }}</th>
                    <th></th>
                    <th class="text-right fee-col">({{ store.totalFees | currency }})</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<!-- Email Overlay/Form -->
<div class="modal-overlay overlay-z2000" *ngIf="isSavingPDFs">
  <div class="processing-box">
    <div class="spinner spinner-mb"></div>
    <p class="processing-text">Processing PDF attachment...</p>
  </div>
</div>

<app-email-form 
  *ngIf="isEmailModalOpen" 
  [to]="emailData.to" 
  [subject]="emailData.subject" 
  [body]="emailData.body"
  [templateType]="'profit_report'"
  (emailSent)="onEmailSent($event)"
  (close)="closeEmailModal(true)" 
  [attachments]="emailData.attachments"
></app-email-form>
